import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  DEFAULT_ORG_STATUS,
  ORG_STATUS_ACTIVE_CLASSNAMES,
  type OrgStatus,
} from "@/constants/orgStatus";

interface OrgStatusTabsProps {
  value: OrgStatus;
  onValueChange: (value: OrgStatus) => void;
  ariaLabel: string;
  activeLabel: string;
  archivedLabel: string;
  className?: string;
}

export const OrgStatusTabs = ({
  value,
  onValueChange,
  ariaLabel,
  activeLabel,
  archivedLabel,
  className,
}: OrgStatusTabsProps) => {
  const options: { value: OrgStatus; label: string }[] = [
    { value: DEFAULT_ORG_STATUS, label: activeLabel },
    { value: "archived", label: archivedLabel },
  ];

  return (
    <Tabs
      value={value}
      onValueChange={newValue => onValueChange(newValue as OrgStatus)}
      className={className ?? "shrink-0"}
    >
      <TabsList aria-label={ariaLabel}>
        {options.map(option => (
          <TabsTrigger
            key={option.value}
            value={option.value}
            className={ORG_STATUS_ACTIVE_CLASSNAMES[option.value]}
          >
            {option.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
